import bulkTemplateDeUrl from './templates/OC_Template_Bulk_de-DE.xlsx?url';
import bulkTemplateEnUrl from './templates/OC_Template_Bulk_en-GB.xlsx?url';
import cargoTemplateDeUrl from './templates/OC_Template_Cargo_de-DE.xlsx?url';
import cargoTemplateEnUrl from './templates/OC_Template_Cargo_en-GB.xlsx?url';

export type OrderImportTemplateKind = 'bulk' | 'cargo';

type OrderImportTemplate = {
    fileName: string;
    url: string;
};

const TEMPLATES: Record<'de-DE' | 'en-GB', Record<OrderImportTemplateKind, OrderImportTemplate>> = {
    'de-DE': {
        bulk: {
            fileName: 'OC_Template_Bulk_de-DE.xlsx',
            url: bulkTemplateDeUrl,
        },
        cargo: {
            fileName: 'OC_Template_Cargo_de-DE.xlsx',
            url: cargoTemplateDeUrl,
        },
    },
    'en-GB': {
        bulk: {
            fileName: 'OC_Template_Bulk_en-GB.xlsx',
            url: bulkTemplateEnUrl,
        },
        cargo: {
            fileName: 'OC_Template_Cargo_en-GB.xlsx',
            url: cargoTemplateEnUrl,
        },
    },
};

export const getOrderImportTemplate = (kind: OrderImportTemplateKind, locale: string) => {
    const templateLocale = locale.toLocaleLowerCase().split('-')[0] === 'de' ? 'de-DE' : 'en-GB';
    return TEMPLATES[templateLocale][kind];
};

export const downloadOrderImportTemplate = (kind: OrderImportTemplateKind, locale: string) => {
    const { fileName, url } = getOrderImportTemplate(kind, locale);
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
};
